import getMessage, { PhraseTranslationKeys } from './get-message';
import { getSegments } from './helpers';

type Args = { [key: string]: string };

type Plural = {
    one: string | null;
    other: string | null;
    zero: string | null;
};
type PhraseValue = null | string | undefined | Plural;

function isPlural(phraseValue?: PhraseValue): phraseValue is Plural {
    return typeof phraseValue === 'object';
}

function translate(
    id: PhraseTranslationKeys,
    args: Args = {},
    fallback?: PhraseTranslationKeys
): string {
    const str = getMessage(id);
    if (str === undefined || str == null) {
        if (fallback) {
            try {
                const fallbackTranslation = getMessage(fallback);
                if (isPlural(fallbackTranslation)) {
                    return fallbackTranslation.one;
                }
                if (fallbackTranslation) return fallbackTranslation || '';
            } catch {
                return id;
            }
        }
        return id;
    }
    // 'a string with {a} variable' -> ['a string with ', '{a}', ' variable']
    const segments = getSegments(isPlural(str) ? str.one : str);
    const response = segments.map(segment => {
        if (segment.startsWith('{')) {
            // '{var}' -> 'var'
            const key = segment.replace('{', '').replace('}', '');
            return args[key] !== undefined ? args[key] : segment;
        } else {
            return segment;
        }
    });

    return response.join('');
}

export default translate;
